<template>
  <b-form-group :label-class='labelclass' :label="label" :class="`${classFormGroupBind} b-form-group-styled`" :invalid-feedback="invalidFeedback"
    :description="descriptionField()" :state="error && error.$error ? false : null">
    <b-form-textarea :value="value" @input="($value) => $emit('input', $value)" v-bind="$attrs" :rows="rows"
      :max-rows="maxRows" :placeholder="descriptionField()"
      :state="error && error.$error ? false : null"></b-form-textarea>
  </b-form-group>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    cols: String,
    sm: String,
    md: String,
    rows: {
      type: Number,
      default: 3,
    },
    maxRows: {
      type: Number,
      default: 6,
    },
    labelclass: {
      type: String,
      default: "",
    },
    classFormGroup: {
      type: String,
      default: "",
    },
    label: String,
    value: [String, Number],
    invalidFeedback: {
      typeof: String,
      default: null,
    },
    description: {
      typeof: String,
      default: "Digite um valor válido",
    },
    error: {
      type: Object,
      default: null,
    },
  },
  computed: {
    classFormGroupBind() {
      const responsiveCols =
        (this.cols !== undefined ? `col-${this.cols} ` : "") +
        (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
        (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 "
      return `${responsiveCols} ${this.classFormGroup}`
    },
  },
  methods: {
    descriptionField() {
      if (this.$attrs.readonly) {
        return "Não editável"
      }
      return !this.error || !this.error.$error ? this.description : ""
    },
  },
}
</script>
<style scoped>
.b-form-group-styled {
  font-size: 12px;
}

.b-form-input-styled {
  max-height: 21px;
  margin-top: -8px;
}
</style>
